export default __webpack_public_path__ + "img/shape-heart.fce944e2.svg";